import React from 'react';
import Link from '../Link/Link';
import dateHelper from '../../util/dateHelper';
import FooterLogo from './FooterLogo';

const SocialAndTerms = () => {
  const year = dateHelper.getFullYear();
  return (
    <div className="common-footer__social-and-terms">
      <div className="zola-logo">
        <FooterLogo />
      </div>
      <div className="tagline">The wedding company that&#39;ll do anything for love.</div>
      <ul className="social-icons">
        <li>
          <Link
            href="https://www.facebook.com/zola"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
            subtle
          >
            <i className="zola-ui-icon zola-ui-icon-facebook" aria-hidden="true" />
          </Link>
        </li>
        <li>
          <Link
            href="https://pinterest.com/zola"
            aria-label="Pinterest"
            target="_blank"
            rel="noopener noreferrer"
            subtle
          >
            <i className="zola-ui-icon zola-ui-icon-pinterest-circled" aria-hidden="true" />
          </Link>
        </li>
        <li>
          <Link
            href="https://twitter.com/zola"
            aria-label="Twitter"
            target="_blank"
            rel="noopener noreferrer"
            subtle
          >
            <i className="zola-ui-icon zola-ui-icon-twitter" aria-hidden="true" />
          </Link>
        </li>
        <li>
          <Link
            href="https://instagram.com/zola"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
            subtle
          >
            <i className="zola-ui-icon zola-ui-icon-instagram" aria-hidden="true" />
          </Link>
        </li>
      </ul>
      <div className="hashtag">@ZOLA | #ANYTHINGFORLOVE</div>
      <div className="copyright">
        &copy; <span className="date">{year}</span> Zola, Inc. All rights reserved.
      </div>
      <ul className="terms-links">
        <li>
          <Link href="/privacy" target="_blank" rel="noopener noreferrer" subtle>
            Privacy Policy
          </Link>
        </li>
        <li>
          <Link href="/terms" target="_blank" rel="noopener noreferrer" subtle>
            Terms of Use
          </Link>
        </li>
        <li>
          <Link href="/webaccessibility" target="_self" subtle>
            Web Accessibility
          </Link>
        </li>
        <li>
          <Link href="/privacy#CA-privacy-rights" target="_blank" rel="noopener noreferrer" subtle>
            Your CA Privacy Rights
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SocialAndTerms;
